import appApi from '../../../api/app-api';
import { HomeData } from '../../../api/types/home-data/home-data';

export const getHomeDataOperation = async (
  branchId: number | undefined,
  setData: (data: HomeData) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (!branchId) {
      return;
    }
    setLoading(true);
    const getHomeRes = await appApi.getHome(
      branchId,
      new Date(new Date().setHours(0, 0, 0, 0)), // Today at 00:00
      new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000), // Tomorrow at 00:00
    );
    setData(getHomeRes.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(`getHomeDataOperation is failed with the error: ${e}`);
  }
};
